export default __webpack_public_path__ + "static/media/Hawk_Icon.5ecd787d.png";